import React, { Fragment, useState, useEffect, useRef, useContext, useCallback } from "react";
import StoryService from "../../../services/StoryService";
import { useTranslation } from "react-i18next";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import {
  AWS_URL,
  REDUX_LOCAL_STORE_KEY,
} from "../../../components/config/constants";
import Stories from "react-insta-stories";
import Carousel from "react-elastic-carousel";
import Loader from "../../../components/Loader.jsx";
import { Link } from "react-router-dom";
import { X, VolumeX, Volume2, ChevronLeft, ChevronRight, Eye, MoreHorizontal, AlertCircle, DollarSign, Plus, Heart, MessageCircle, Trash2, ThumbsUp } from "lucide-react";
import TipModal from "../Tip/TipModal";
import { SocketContext } from "../../../context/SocketContext";
import ReportModal from "../../../components/common/commonModal/ReportModal.jsx";
import Modal from "react-bootstrap/Modal";
import { MultiNumber } from "../../../components/common/MultiNumber.jsx";
import { USER_TYPES } from "../../../components/config/constants";
import { getUserProfilePic } from "../../../components/helper/GeneralHelper";
import DefaultAvatar from "../../../components/common/DefaultAvatar.jsx";
import AccountVerifyTick from "../../../components/common/AccountVerifyTick.jsx";
import { useHistory, useLocation } from "react-router-dom";

const StoriesComponent = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const socketContext = useContext(SocketContext);

  const clickSendMessage = useRef(null);
  let carouselRef = useRef(null);
  const width = window.innerWidth;
  const isMobile = width <= 512;
  const isTab = width <= 9999;

  // Guard: redirect if no currentCreator in location state
  if (location.state?.currentCreator === undefined) {
    history.push("/");
    window.location.reload();
  }

  const [state, setState] = useState({
    from: location.state?.from,
    arrayStoryUrl: [""],
    currentCreator:
      (location.state?.currentCreator || 0) +
      (isMobile ? 0 : isTab ? 1 : 2),
    creatorDetails: JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
      .authentication.userData,
    storyList: location.state?.storyList
      ? isMobile
        ? [...location.state?.storyList]
        : isTab
        ? [
            { blank: true },
            ...location.state?.storyList,
            { blank: true },
          ]
        : [
            { blank: true },
            { blank: true },
            ...location.state?.storyList,
            { blank: true },
            { blank: true },
          ]
      : null,
    currentStory: 0,
    isStoryMuted: false,
    showOption: false,
    showModalTip: false,
    showModalReport: false,
    messageValue: "",
    showModalStatistics: false,
    storyLikeList: [],
    myStories: [],
    showModalDelete: false,
    doMessage: false,
  });

  // We need a ref to track latest state for callbacks used in Carousel/Stories
  const stateRef = useRef(state);
  stateRef.current = state;

  const muteAllVideos = useCallback((muted) => {
    const videoElements = document.getElementsByTagName("video");
    for (let i = 0; i < videoElements.length; i++) {
      videoElements[i].muted = muted;
    }
  }, []);

  const visualizeStory = useCallback((storyId) => {
    if (location.state?.isArchiveStory === false) {
      if (!storyId) {
        const currentState = stateRef.current;
        storyId =
          currentState.arrayStoryUrl[
            currentState.arrayStoryUrl[currentState.currentStory]
              ? currentState.currentStory
              : 0
          ]?.id;
      }
      if (!storyId) return;
      StoryService.visualizeStory({ storyId })
        .then(() => {})
        .catch((err) => toast.error(err.message));
    }
  }, [location.state?.isArchiveStory]);

  const newArrayStory = useCallback(() => {
    const currentState = stateRef.current;
    if (location.state?.isArchiveStory === false) {
      const arrayStories = currentState.storyList[
        currentState.currentCreator
      ]?.stories?.map((value) => ({
        url: value.storyMedia.storyUrl,
        type: value.storyMedia.type,
        id: value._id,
        liked: value.userStoryDetails[0]?.liked
          ? value.userStoryDetails[0]?.liked
          : false,
      }));
      muteAllVideos(currentState.isStoryMuted);
      setState((prev) => ({ ...prev, arrayStoryUrl: arrayStories || [""], currentStory: 0 }));
      setTimeout(() => visualizeStory(arrayStories?.[0]?.id), 0);
    } else {
      const storyItem = currentState.storyList[currentState.currentCreator];
      const arrayStories = [
        {
          url: `${storyItem?.storyMedia?.storyUrl}`,
          type: storyItem?.storyMedia?.type,
          id: storyItem?._id,
          liked: false,
        },
      ];
      muteAllVideos(currentState.isStoryMuted);
      setState((prev) => ({ ...prev, arrayStoryUrl: arrayStories, currentStory: 0 }));
      setTimeout(() => visualizeStory(arrayStories?.[0]?.id), 0);
    }
  }, [location.state?.isArchiveStory, muteAllVideos, visualizeStory]);

  const displayAllStory = useCallback(() => {
    const currentState = stateRef.current;
    if (carouselRef.current?.goTo) {
      carouselRef.current.goTo(
        currentState.currentCreator - (isMobile ? 0 : isTab ? 1 : 2)
      );
    }
    const storyItem = currentState.storyList?.[currentState.currentCreator];
    if (storyItem?.stories) {
      const firstStory = storyItem.stories.map((value) => ({
        url: value.storyMedia.storyUrl,
        type: value.storyMedia.type,
        id: value._id,
        liked: value.userStoryDetails[0]?.liked
          ? value.userStoryDetails[0]?.liked
          : false,
      }));
      setState((prev) => ({ ...prev, arrayStoryUrl: firstStory, currentStory: 0 }));
      setTimeout(() => visualizeStory(firstStory?.[0]?.id), 0);
    }
  }, [isMobile, isTab, visualizeStory]);

  const getStoryLike = useCallback((storyId) => {
    let params = {
      storyId: storyId,
      page: 0,
      limit: 250,
    };
    StoryService.getStoryLike({ ...params })
      .then((res) => setState((prev) => ({ ...prev, storyLikeList: res.data.data[0].data })))
      .catch(() => {});
  }, []);

  const getStoryListFirst = useCallback(() => {
    StoryService.myStories()
      .then((res) => {
        let myStories = {
          creatorDetails: {
            name: JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
              .authentication.userData.name,
            profilePicture: JSON.parse(
              localStorage.getItem(REDUX_LOCAL_STORE_KEY)
            ).authentication.userData.profilePicture,
            userName: JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
              .authentication.userData.userName,
            _id: JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
              .authentication.userData._id,
            isCreatorVerified: JSON.parse(
              localStorage.getItem(REDUX_LOCAL_STORE_KEY)
            ).authentication.userData.isCreatorVerified,
          },
          stories: res.data.data,
          subscribedCreatorId: JSON.parse(
            localStorage.getItem(REDUX_LOCAL_STORE_KEY)
          ).authentication.userData._id,
        };
        setState((prev) => ({ ...prev, myStories }));

        StoryService.storyList()
          .then((storyRes) => {
            const newStoryList =
              myStories?.stories?.length > 0
                ? isMobile
                  ? [myStories, ...storyRes.data.data]
                  : isTab
                  ? [
                      { blank: true },
                      myStories,
                      ...storyRes.data.data,
                      { blank: true },
                    ]
                  : [
                      { blank: true },
                      { blank: true },
                      myStories,
                      ...storyRes.data.data,
                      { blank: true },
                      { blank: true },
                    ]
                : isMobile
                ? [...storyRes.data.data]
                : isTab
                ? [{ blank: true }, ...storyRes.data.data, { blank: true }]
                : [
                    { blank: true },
                    { blank: true },
                    ...storyRes.data.data,
                    { blank: true },
                    { blank: true },
                  ];

            setState((prev) => ({ ...prev, storyList: newStoryList }));
            // Need to call displayAllStory after storyList is set
            setTimeout(() => displayAllStory(), 0);
          })
          .catch((err) => {
            toast.error(err.message);
          });
      })
      .catch(() => {});
  }, [isMobile, isTab, displayAllStory]);

  const getStoryList = useCallback(() => {
    StoryService.storyList()
      .then((res) => {
        const newStoryList = isMobile
          ? [...res.data.data]
          : isTab
          ? [{ blank: true }, ...res.data.data, { blank: true }]
          : [
              { blank: true },
              { blank: true },
              ...res.data.data,
              { blank: true },
              { blank: true },
            ];

        setState((prev) => ({ ...prev, storyList: newStoryList }));
        setTimeout(() => displayAllStory(), 0);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [isMobile, isTab, displayAllStory]);

  useEffect(() => {
    if (location.state?.isArchiveStory === true) {
      if (carouselRef.current?.goTo) {
        carouselRef.current.goTo(
          state.currentCreator - (isMobile ? 0 : isTab ? 1 : 2)
        );
      }
      newArrayStory();
    } else {
      let isCreator =
        JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY)).authentication
          ?.userData?.userType === USER_TYPES.CREATOR;
      if (isCreator) {
        getStoryListFirst();
      } else {
        getStoryList();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollPrev = useCallback(() => {
    if (carouselRef.current?.slidePrev) {
      carouselRef.current.slidePrev();
    }
    setState((prev) => {
      const newCreator = prev.currentCreator - 1;
      return { ...prev, currentCreator: newCreator };
    });
    setTimeout(() => newArrayStory(), 0);
  }, [newArrayStory]);

  const sendMessage = useCallback(() => {
    let params = {
      senderId: JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
        .authentication.userData._id,
      receiverId:
        stateRef.current.storyList[stateRef.current.currentCreator]?.creatorDetails?._id,
      message: {
        text: stateRef.current.messageValue,
        messagePrice: null,
        media: [],
      },
    };
    socketContext?.socket?.emit("add_message", params);
    setState((prev) => ({ ...prev, messageValue: "" }));
  }, [socketContext]);

  const scrollNext = useCallback(() => {
    const currentState = stateRef.current;
    if (
      currentState.currentCreator ===
      currentState.storyList.length - (isMobile ? 1 : isTab ? 2 : 3)
    ) {
      setState((prev) => ({ ...prev, currentStory: prev.currentStory + 1 }));
      setTimeout(() => {
        if (stateRef.current.from === "archive") {
          window.location.pathname = "/archive";
        } else {
          window.location.pathname = "/";
        }
      }, 0);
    } else {
      if (carouselRef.current?.slideNext) {
        carouselRef.current.slideNext();
      }
      setState((prev) => ({ ...prev, currentCreator: prev.currentCreator + 1 }));
      setTimeout(() => newArrayStory(), 0);
    }
  }, [isMobile, isTab, newArrayStory]);

  const muteStory = useCallback(() => {
    setState((prev) => {
      const newMuted = !prev.isStoryMuted;
      setTimeout(() => muteAllVideos(newMuted), 0);
      return { ...prev, isStoryMuted: newMuted };
    });
  }, [muteAllVideos]);

  const clickStory = useCallback((storyIndex) => {
    if (carouselRef.current?.goTo) {
      carouselRef.current.goTo(
        storyIndex - (isMobile ? 0 : isTab ? 1 : 2)
      );
    }
    setState((prev) => ({ ...prev, currentCreator: storyIndex }));
    setTimeout(() => newArrayStory(), 0);
  }, [isMobile, isTab, newArrayStory]);

  const likeOrDislike = useCallback(() => {
    let params = {
      storyId: stateRef.current.arrayStoryUrl[stateRef.current.currentStory]?.id,
    };
    StoryService.likeStory({ ...params })
      .then(() => {
        setState((prev) => {
          let storyList = [...prev.storyList];
          let arrayStoryUrl = [...prev.arrayStoryUrl];
          arrayStoryUrl[prev.currentStory] = {
            ...arrayStoryUrl[prev.currentStory],
            liked: arrayStoryUrl[prev.currentStory].liked
              ? !arrayStoryUrl[prev.currentStory].liked
              : true,
          };
          if (storyList[prev.currentCreator]?.stories?.[prev.currentStory]) {
            storyList[prev.currentCreator] = { ...storyList[prev.currentCreator] };
            storyList[prev.currentCreator].stories = [...storyList[prev.currentCreator].stories];
            storyList[prev.currentCreator].stories[prev.currentStory] = {
              ...storyList[prev.currentCreator].stories[prev.currentStory],
            };
            storyList[prev.currentCreator].stories[prev.currentStory].userStoryDetails = [{}];
            storyList[prev.currentCreator].stories[prev.currentStory].userStoryDetails[0].liked =
              arrayStoryUrl[prev.currentStory].liked;
          }
          return { ...prev, arrayStoryUrl, storyList };
        });
      })
      .catch(() => {});
  }, []);

  const deleteStory = useCallback((storyId) => {
    let params = {
      storyId: storyId,
    };
    StoryService.deleteStorie({ ...params })
      .then(() => {
        history.push("/");
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [history]);

  return (
    <Fragment>
      <div
        onClick={() => {
          if (state.showOption === true) {
            setState((prev) => ({ ...prev, showOption: false }));
          }
        }}
        className="stories-page"
      >
        <div className="carousel-controls"></div>
        <Carousel
          ref={(ref) => (carouselRef.current = ref)}
          enableSwipe={true}
          showArrows={false}
          pagination={false}
          className="align-center"
          breakPoints={[
            {
              width: 0,
              itemsToShow: isMobile ? 1 : isTab ? 3 : 5,
            },
          ]}
          onChange={(event) => {
            const newCreator = event.index + (isMobile ? 0 : 1);
            setState((prev) => ({ ...prev, currentCreator: newCreator }));
            setTimeout(() => newArrayStory(), 0);
          }}
        >
          {state.storyList?.map((value, index) => (
            <div key={index}>
              {index === state.currentCreator ? (
                <>
                  <div className="story-card-current flex-paginator">
                    {isMobile === false &&
                    state.currentCreator - (isMobile ? 0 : 1) >
                      0 ? (
                      <span
                        onClick={() => scrollPrev()}
                        className="arrow-story-left hover"
                      >
                        <ChevronLeft size={20} />
                      </span>
                    ) : (
                      <span
                        className={`${
                          isMobile === false && "arrow-story-left"
                        }`}
                        style={{ boxShadow: "none", opacity: 0 }}
                      ></span>
                    )}

                    <span className="story-style">
                      <span
                        onClick={() =>
                          history.push(
                            `/${value.creatorDetails?.userName}`
                          )
                        }
                        style={{ position: "absolute" }}
                        className="ultra-fix-story hover story-creator-icon"
                      >
                        <div className="flex-paginator fix-story-icon">
                          <span className="picture-story">
                            {location.state?.isArchiveStory ? (
                              <DefaultAvatar
                                fontSize={"14px"}
                                width={"32px"}
                                height={"32px"}
                                id={state.creatorDetails?._id}
                                userName={state.creatorDetails?.name}
                              >
                                {state.creatorDetails?.profilePicture ? (
                                  <Image
                                    className="picture-story"
                                    width={"32px"}
                                    height={"32px"}
                                    alt={state.creatorDetails?.name}
                                    title={state.creatorDetails?.name}
                                    src={getUserProfilePic(
                                      state.creatorDetails?._id,
                                      state.creatorDetails
                                        ?.profilePicture
                                    )}
                                  ></Image>
                                ) : null}
                              </DefaultAvatar>
                            ) : (
                              <DefaultAvatar
                                fontSize={"14px"}
                                width={"32px"}
                                height={"32px"}
                                userName={value.creatorDetails?.name}
                                id={value.subscribedCreatorId}
                              >
                                {value.creatorDetails?.profilePicture ? (
                                  <Image
                                    className="picture-story"
                                    width={"32px"}
                                    height={"32px"}
                                    alt={value.creatorDetails?.name}
                                    title={value.creatorDetails?.name}
                                    src={getUserProfilePic(
                                      value.subscribedCreatorId,
                                      value.creatorDetails?.profilePicture
                                    )}
                                  ></Image>
                                ) : null}
                              </DefaultAvatar>
                            )}
                          </span>
                          <span className="hover story-creators-name">
                            {location.state?.isArchiveStory
                              ? state.creatorDetails?.name
                              : value.creatorDetails?.name}{" "}
                            {location.state?.isArchiveStory ? (
                              state.creatorDetails?.isCreatorVerified ? (
                                <span
                                  style={{
                                    marginLeft: "2px",
                                    verticalAlign: "text-bottom",
                                  }}
                                >
                                  <AccountVerifyTick width="15px"></AccountVerifyTick>
                                </span>
                              ) : null
                            ) : value.creatorDetails?.isCreatorVerified ? (
                              <span
                                style={{
                                  marginLeft: "2px",
                                  verticalAlign: "text-bottom",
                                }}
                              >
                                <AccountVerifyTick width="15px"></AccountVerifyTick>
                              </span>
                            ) : null}
                          </span>
                        </div>
                      </span>
                      <span className="fix-story-100-width remove-option-image-iphone-chrome">
                        <Stories
                          isPaused={
                            state.showModalTip ||
                            state.showModalReport ||
                            state.showModalDelete
                          }
                          stories={state.arrayStoryUrl}
                          defaultInterval={15000}
                          width={
                            isMobile
                              ? "100vw"
                              : "calc(86.6666666vh * 0.560897)"
                          }
                          height={isMobile ? "100vh" : "86.6666666vh"}
                          loop={false}
                          onAllStoriesEnd={scrollNext}
                          muted={state.isStoryMuted}
                          loader={<Loader />}
                          onStoryStart={() => {
                            visualizeStory();
                          }}
                          onStoryEnd={() =>
                            setState((prev) => ({
                              ...prev,
                              currentStory: prev.currentStory + 1,
                            }))
                          }
                          onNext={() =>
                            setState((prev) => {
                              const newStory = prev.currentStory + 1;
                              setTimeout(() => visualizeStory(), 0);
                              return { ...prev, currentStory: newStory };
                            })
                          }
                          onPrevious={() =>
                            setState((prev) => ({
                              ...prev,
                              currentStory:
                                prev.currentStory -
                                (prev.currentStory > 0 ? 1 : 0),
                            }))
                          }
                        />
                      </span>
                    </span>
                    {location.state?.isArchiveStory === false && (
                      <span
                        onClick={() =>
                          setState((prev) => ({
                            ...prev,
                            showOption: !prev.showOption,
                          }))
                        }
                        className="story-option-button"
                        name="no-close"
                      >
                        <MoreHorizontal size={20} />
                        {state.showOption && (
                          <div name="no-close" className="option-story-div">
                            {value.creatorDetails._id !==
                              JSON.parse(
                                localStorage.getItem(REDUX_LOCAL_STORE_KEY)
                              ).authentication.userData._id && (
                              <div
                                name="no-close"
                                className="d-flex justify-content-start align-items-center"
                                onClick={() =>
                                  setState((prev) => ({ ...prev, showModalReport: true }))
                                }
                              >
                                <AlertCircle
                                  size={18}
                                  style={{
                                    position: "relative",
                                    marginRight: "4px",
                                  }}
                                />{" "}
                                {t("stories.report")}
                              </div>
                            )}
                            {value.creatorDetails._id !==
                              JSON.parse(
                                localStorage.getItem(REDUX_LOCAL_STORE_KEY)
                              ).authentication.userData._id && (
                              <div
                                name="no-close"
                                className="d-flex justify-content-start align-items-center"
                                onClick={() =>
                                  setState((prev) => ({ ...prev, showModalTip: true }))
                                }
                              >
                                <DollarSign
                                  size={18}
                                  style={{
                                    position: "relative",
                                    marginRight: "4px",
                                  }}
                                />{" "}
                                {t("stories.tip")}
                              </div>
                            )}
                            {value.creatorDetails._id ===
                              JSON.parse(
                                localStorage.getItem(REDUX_LOCAL_STORE_KEY)
                              ).authentication.userData._id && (
                              <div
                                name="no-close"
                                className="d-flex justify-content-start align-items-center"
                                onClick={() => {
                                  setState((prev) => ({ ...prev, showModalDelete: true }));
                                }}
                              >
                                <Trash2
                                  size={18}
                                  style={{
                                    position: "relative",
                                    marginRight: "4px",
                                  }}
                                />{" "}
                                {t("stories.delete")}
                              </div>
                            )}
                          </div>
                        )}
                      </span>
                    )}
                    {location.state?.isArchiveStory === false && (
                      <span
                        onClick={() => muteStory()}
                        className="mute-button"
                      >
                        {state.isStoryMuted === false ? (
                          <Volume2 size={20} />
                        ) : (
                          <VolumeX size={20} />
                        )}
                      </span>
                    )}

                    {isMobile && (
                      <span
                        onClick={() => history.goBack()}
                        className="close-story-button"
                      >
                        <X size={20} style={{ color: "white" }} />
                      </span>
                    )}

                    {isMobile === false &&
                      state.currentCreator + (isMobile ? 0 : 1) <
                        state.storyList?.length && (
                        <span
                          onClick={() => scrollNext()}
                          className="arrow-story-right hover"
                        >
                          <ChevronRight size={20} />
                        </span>
                      )}
                  </div>
                  {/* Segnaposto */}
                  {location.state?.isArchiveStory ? (
                    <div
                      onClick={() => {
                        getStoryLike(value._id);
                        setState((prev) => ({ ...prev, showModalStatistics: true }));
                      }}
                      className="footer-story-extra hover"
                      style={{ color: "white", zIndex: 999 }}
                    >
                      <div
                        className="d-flex justify-content-center align-items-center text-shadow-20px-black"
                        style={{ gap: "8px" }}
                      >
                        <Eye size={18} />
                        <span className="f-14px-16px">
                          {t("archive.seeStatistics")}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <>
                      {JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
                        .authentication.userData._id ===
                      value?.creatorDetails?._id ? (
                        <div
                          onClick={() => {
                            getStoryLike(
                              value?.stories[state.currentStory]?._id
                            );
                            setState((prev) => ({ ...prev, showModalStatistics: true }));
                          }}
                          className="footer-story-extra hover"
                          style={{ color: "white", zIndex: 999 }}
                        >
                          <div
                            className="d-flex justify-content-center align-items-center text-shadow-20px-black"
                            style={{ gap: "8px" }}
                          >
                            <Eye size={18} />
                            <span className="f-14px-16px">
                              {t("archive.seeStatistics")}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="footer-story-extra">
                          <div className="footer-story">
                            <span
                              className="border-message-story d-flex justify-content-center align-items-center"
                              style={{ height: "35px" }}
                            >
                              <input
                                placeholder={t(
                                  "stories.sendMessage"
                                )}
                                style={{
                                  width: isMobile
                                    ? window.innerWidth - 60 + "px"
                                    : "280px",
                                }}
                                onKeyUp={(e) => {
                                  if (e.code === "Enter") {
                                    clickSendMessage.current.click();
                                  }
                                }}
                                onChange={(value) =>
                                  setState((prev) => ({
                                    ...prev,
                                    messageValue: value.target.value,
                                  }))
                                }
                                className="message-story"
                                type="text"
                                value={state.messageValue}
                              ></input>
                            </span>
                            <span
                              style={{ display: "none" }}
                              onClick={() => sendMessage()}
                              ref={clickSendMessage}
                              className="footer-story-icon hover"
                            >
                              <MessageCircle
                                size={20}
                                style={{ color: "white" }}
                              />
                            </span>
                            <span
                              style={{ height: "35px" }}
                              className="footer-story-icon hover d-flex justify-content-center align-items-center"
                              onClick={() => likeOrDislike()}
                            >
                              {state?.arrayStoryUrl[
                                state.currentStory
                              ]?.liked === true ? (
                                <Heart size={20} className="filled-heart" />
                              ) : (
                                <Heart size={20} />
                              )}
                            </span>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  {value?.blank === true ? (
                    <>
                      {index === 0 &&
                      location.state?.isArchiveStory === false &&
                      JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
                        .authentication.userData.userType ===
                        USER_TYPES.CREATOR ? (
                        <div
                          onClick={() =>
                            history.push("/upload-stories")
                          }
                          className={`story-card-background hover`}
                        >
                          <div
                            style={{ textAlign: "-webkit-center" }}
                            className="hover"
                          >
                            <div className="story-add">
                              <Plus size={20} />
                            </div>
                            <div
                              style={{ width: "100%", marginTop: "8px" }}
                              className="stories-add-story-text"
                            >
                              {t("stories.addYourStories")}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className={`story-card-blank`}></div>
                      )}
                    </>
                  ) : (
                    <div
                      onClick={() => clickStory(index)}
                      className={`story-card-background hover`}
                      style={{
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundImage: `url(${
                          (value?.stories
                            ? value.stories[0]
                            : value
                          ).storyMedia?.type?.includes("video")
                            ? (value?.stories ? value.stories[0] : value)
                                .storyMedia.thumbnailUrl
                            : (value?.stories ? value.stories[0] : value)
                                .storyMedia?.storyUrl
                        })`,
                      }}
                    >
                      <div className="story-box-extra hover">
                        <div className="story-box">
                          {location.state?.isArchiveStory ? (
                            <DefaultAvatar
                              id={state.creatorDetails?._id}
                              userName={state.creatorDetails?.name}
                              width={"52px"}
                              height={"52px"}
                              className={`${
                                !location.state?.isArchiveStory
                                  ? value.stories.some(
                                      (storie) =>
                                        storie?.userStoryDetails?.length > 0
                                    )
                                    ? "story-img-border-gray"
                                    : "story-img-border"
                                  : "story-img-border-gray"
                              }`}
                            >
                              {state.creatorDetails?.profilePicture ? (
                                <Image
                                  className={`${
                                    !location.state?.isArchiveStory
                                      ? value.stories.some(
                                          (storie) =>
                                            storie?.userStoryDetails?.length >
                                            0
                                        )
                                        ? "story-img-border-gray"
                                        : "story-img-border"
                                      : "story-img-border-gray"
                                  }`}
                                  style={{ borderRadius: "99px" }}
                                  width={52}
                                  height={52}
                                  alt={state.creatorDetails?.name}
                                  title={state.creatorDetails?.name}
                                  src={getUserProfilePic(
                                    state.creatorDetails?._id,
                                    state.creatorDetails?.profilePicture
                                  )}
                                ></Image>
                              ) : null}
                            </DefaultAvatar>
                          ) : (
                            <DefaultAvatar
                              id={value.subscribedCreatorId}
                              className={`${
                                !location.state?.isArchiveStory
                                  ? value.stories.some(
                                      (storie) =>
                                        storie?.userStoryDetails?.length > 0
                                    )
                                    ? "story-img-border-gray"
                                    : "story-img-border"
                                  : "story-img-border-gray"
                              }`}
                              userName={value.creatorDetails?.name}
                              width={"52px"}
                              height={"52px"}
                            >
                              {value.creatorDetails?.profilePicture ? (
                                <Image
                                  className={`${
                                    !location.state?.isArchiveStory
                                      ? value.stories.some(
                                          (storie) =>
                                            storie?.userStoryDetails?.length >
                                            0
                                        )
                                        ? "story-img-border-gray"
                                        : "story-img-border"
                                      : "story-img-border-gray"
                                  }`}
                                  style={{ borderRadius: "99px" }}
                                  width={52}
                                  height={52}
                                  alt={value.creatorDetails?.name}
                                  title={value.creatorDetails?.name}
                                  src={getUserProfilePic(
                                    value.subscribedCreatorId,
                                    value.creatorDetails?.profilePicture
                                  )}
                                ></Image>
                              ) : null}
                            </DefaultAvatar>
                          )}
                        </div>
                        <div className="story-box-name">
                          {value.creatorDetails?.name}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
        </Carousel>
        {isMobile === false && (
          <>
            <div className="red-circle-story">
              <Link to="/" style={{ paddingLeft: "24px", gap: "7.24px" }}>
                <img
                  className="logo-red-circle"
                  src={`${AWS_URL}logo/logoRedCircle.png`}
                  alt=""
                ></img>
                <img
                  className="logo-red-circle"
                  src={`${AWS_URL}logo/${
                    localStorage.getItem("theme") === "theme-light"
                      ? "RedCircleBlack.png"
                      : "RedCircleRed.png"
                  }`}
                  alt=""
                ></img>
                {localStorage.getItem("theme") === "theme-dark"}
              </Link>
            </div>
            <div className="close-story">
              <div
                onClick={() => {
                  if (state.from === "archive") {
                    window.location.pathname = "/archive";
                  } else {
                    window.location.pathname = "/";
                  }
                }}
                style={{ justifyContent: "center", gap: "7.24px" }}
                className="hover"
              >
                <X size={20} className="close-x" />
              </div>
            </div>
          </>
        )}
      </div>
      {state.showModalTip && (
        <TipModal
          userName={
            state.storyList[state.currentCreator]?.creatorDetails
              ?.userName
          }
          show={state.showModalTip}
          onHide={() => setState((prev) => ({ ...prev, showModalTip: false }))}
          id={
            state.storyList[state.currentCreator]
              ?.subscribedCreatorId
          }
          objId={
            state.storyList[state.currentCreator]?.stories[
              state.currentStory
            ]?._id
          }
          tipArea={"STORIES"}
        />
      )}
      {state.showModalReport && (
        <ReportModal
          type={3}
          reported={
            state.storyList[state.currentCreator]
              ?.subscribedCreatorId
          }
          id={state.storyList[state.currentCreator]?.stories[0]?._id}
          show={state.showModalReport}
          onHide={() => setState((prev) => ({ ...prev, showModalReport: false }))}
        />
      )}
      <Modal
        show={state.showModalDelete}
        onHide={() => setState((prev) => ({ ...prev, showModalDelete: false }))}
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="ps-3 pt-2 pb-2">
          <span className="text-color-dark fw-700 font-xssss">
            {t("stories.delete")}
          </span>
        </Modal.Header>
        <Modal.Body
          className={`p-4 add-card-modal ${
            state.doMessage === true ? "pb-0" : ""
          }`}
        >
          <span className="text-color-dark fw-400 font-xssss">
            {t("stories.deleteDescription")}
          </span>
        </Modal.Body>
        <Modal.Footer className="d-flex p-2 justify-content-end">
          <div
            className="pointer fw-bold me-4 font-xsss text-silver"
            onClick={() => setState((prev) => ({ ...prev, showModalDelete: false }))}
          >
            {t("common.cancel")}
          </div>
          <Button
            className="fix-tip-button fw-bold me-2 rounded-pill font-xssss text-white px-3 py-2 pointer"
            onClick={() => {
              deleteStory(
                state.storyList[state.currentCreator]?.stories[
                  state.currentStory
                ]?._id
              );
            }}
          >
            {t("account.deleteAccount.modal.confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={state.showModalStatistics}
        onHide={() => setState((prev) => ({ ...prev, showModalStatistics: false }))}
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="ps-3 pt-2 pb-2">
          <span className="text-color-dark fw-700 font-xssss">
            {t("archive.storyStatistics")}
          </span>
        </Modal.Header>
        <Modal.Body
          className={`p-4 add-card-modal stats-modal ${
            state.doMessage === true ? "pb-0" : ""
          }
                          `}
        >
          <div>
            <span className="text-12px">
              {t("archive.totalView")}:{" "}
            </span>
            <span className="select-category-clip">
              <MultiNumber
                numberToFix={
                  state.storyList?.[state.currentCreator]?.totalViews
                    ? state.storyList[state.currentCreator].totalViews
                    : state.storyLikeList[0]?.totalViews
                }
              />{" "}
              {t("archive.followers")}
            </span>
            <span className="text-12px" style={{ marginLeft: "16px" }}>
              {t("archive.totalLkes")}:{" "}
            </span>
            <span className="select-category-clip">
              <MultiNumber
                numberToFix={
                  state.storyList?.[state.currentCreator]
                    ?.storyTotalLikes
                    ? state.storyList[state.currentCreator]
                        .storyTotalLikes
                    : state.storyLikeList[0]?.storyTotalLikes
                }
              />{" "}
              {t("archive.followers")}
            </span>
          </div>

          <div className="scroll-like-story">
            {state.storyLikeList?.map((value, index) => {
              return (
                <div key={index} className="container-user-like-story flex-paginator align-center-only">
                  <span
                    style={
                      !value.userDetails?.profilePicture
                        ? { display: "flex" }
                        : {}
                    }
                  >
                    <DefaultAvatar
                      userName={value.userDetails?.name}
                      width={"48px"}
                      height={"48px"}
                      online={false}
                      id={value.userDetails._id}
                    >
                      {value.userDetails?.profilePicture ? (
                        <Image
                          style={{ borderRadius: "50px" }}
                          width={48}
                          height={48}
                          src={getUserProfilePic(
                            value.userDetails._id,
                            value.userDetails.profilePicture
                          )}
                        ></Image>
                      ) : null}
                    </DefaultAvatar>
                    <span className="user-like-thumbs">
                      <ThumbsUp size={18} />
                    </span>
                  </span>
                  <span>
                    <div className="name-user-story">
                      {value.userDetails.userName}
                    </div>
                    <div className="wallet-info">
                      @{value.userDetails.name}
                    </div>
                  </span>
                </div>
              );
            })}
          </div>
          <Modal.Footer className="d-flex p-2 justify-content-end border-0"></Modal.Footer>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default StoriesComponent;
